//#region src/verticals/payments/PaymentEvent.ts
var e = /* @__PURE__ */ function(e) {
	return e.CheckoutStarted = "payments.checkout.started", e.MethodSelected = "payments.method.selected", e.TransactionCompleted = "payments.transaction.completed", e.TransactionFailed = "payments.transaction.failed", e.RefundInitiated = "payments.refund.initiated", e.CheckoutPageViewed = "payments.page.checkout_viewed", e;
}({});
//#endregion
export { e as PaymentEvent };
